// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';
import { snjPrimary } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/styles/CommonStyle';

const getSpacing = () => '32px';

const getWidth = (props) => {
  if (
    props.isApplePayVisible &&
    !props.isMiniBag &&
    !props.isPayPalDisabled &&
    props.isAdyenPaymentEnabled &&
    props.isBagPageStickyHeader
  ) {
    return '156px';
  }
  if (props.isApplePayVisible && !props.isMiniBag && !props.isPayPalDisabled) {
    return '48%';
  }

  if (props.isApplePayVisible && !props.isMiniBag && props.isPayPalDisabled) {
    return '100%';
  }
  return '0';
};

const ctaStyle = css`
  ${(props) =>
    props.isMiniBag &&
    !props.containsExtendedOrder &&
    `.paypal-venmo-container-adyen {
    width: 50%;
  }`}

  .paymentHidden {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .checkoutBtnTracker .checkout-gym {
    ${(props) => props.theme.brandSpecificStyles.ADDED_TO_BAG_ACTIONS.CHECKOUT_GYM};
  }
  .estimated-tax-simplified-text {
    margin-left: 14px;
    font-size: 15px;
    line-height: 16px;
    letter-spacing: 0.2px;
  }
  .checkout-divider {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isStickyCheckoutButtonEnabled &&
        `
      display: flex;
      justify-content: center;
      margin-bottom:10px;
      font-weight: ${props.theme.typography.fontWeights.regular};
      `};
    }
  }
  .checkout-divider:before,
  .checkout-divider:after {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
      content: '';
      flex: 1;
      border-bottom: groove 1px;
      margin: auto 10px auto 87px;
    }
  }
  .checkout-divider:after {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: auto 87px auto 10px;
    }
  }

  display: block;
  margin-bottom: ${(props) => (props.isBagPageStickyHeader ? '0' : getSpacing())};
  .check-out-container {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }
  .view-bag {
    &:hover {
      background: ${(props) => props.theme.colors.PRIMARY.DARK};
    }
    width: inherit;
    background-color: ${(props) => props.theme.colors.PRIMARY.DARK};
    height: 48px;
  }

  .checkout-button {
    padding-top: 10px;
    position: relative;
    flex-wrap: noWrap;
  }

  .checkout {
    ${(props) => (props.newMiniBag ? `border-radius: 6px;` : '')};
    ${(props) => props.newMiniBag && props.theme.brandSpecificStyles.ADDED_TO_BAG_ACTIONS.CHECKOUT};
    height: 48px;
    margin-left: ${(props) =>
      props.isInternationalShipping || props.isPayPalDisabled
        ? '0px'
        : props.theme.spacing.APP_LAYOUT_SPACING.XXS};
    ${(props) => (!props.isVenmoEnabled && !props.isPayPalEnabled ? `margin-left: 0;` : '')};
    flex: 1;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-left: 0;
    }
  }
  .payPal-button {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: none;
    }
  }

  .after-pay-block {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    position: relative;
    background-image: url('${(props) => getIconPath('Afterpay_Badge_BlackonMint', props)}');
    background-repeat: no-repeat;
    max-width: 100%;
    max-height: 100%;
    background-position: center;
    background-color: ${(props) => props.theme.colors.AFTERPAY.MINT};
    background-size: 40%;
    border: 1px solid black;
    border-radius: 4px;
    box-sizing: border-box;
  }

  .after-pay-container {
    height: 48px;
    opacity: 0;
    overflow: hidden;
    cursor: pointer;
    --afterpay-button-width: 100%;
    --afterpay-button-height: 100%;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 42px;
    }
  }

  .paypal-venmo {
    display: flex;
    margin-bottom: 8px;
    ${(props) =>
      (props.isPLCCInstantCheckout && !props.isApplePayVisible) || props.isExpressAfterpayEnabled
        ? `flex-direction: column;`
        : 'flex-direction: row;'}
    @media ${(props) => props.theme.mediaQuery.mediumOnlyPortrait} {
      flex-direction: column;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isStickyCheckoutButtonEnabled &&
        !props.isCheckoutBannerHidden &&
        `
      display: block;
      `}
      ${(props) =>
        props.isPLCCInstantCheckout && !props.isInternationalShipping
          ? `flex-direction: column;`
          : 'flex-direction: row;'}
    }
  }
  .paypal-wrapper {
    width: ${(props) =>
      props.isApplePayVisible && !props.isMiniBag && !props.isExpressAfterpayEnabled
        ? '48%'
        : '100%'};
    z-index: 0;
    @media ${(props) => props.theme.mediaQuery.large} {
      min-width: ${(props) =>
        props.isApplePayVisible && !props.isMiniBag && !props.isExpressAfterpayEnabled
          ? ''
          : '202px'};
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnlyPortrait} {
      width: 100%;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isStickyCheckoutButtonEnabled &&
        !props.isCheckoutBannerHidden &&
        `
        width: 100%;
      `}
    }
  }
  .apple-wrapper {
    width: ${(props) => getWidth(props)};
    margin-left: ${(props) =>
      props.isApplePayVisible && !props.isMiniBag && !props.isPayPalDisabled ? '2%' : '0'};
    ${(props) =>
      props.isExpressAfterpayEnabled &&
      props.isApplePayVisible &&
      `width: 100%;
      min-width: 110px;
      margin-top: 8px;
      margin-left: 0;
      height: 48px;
    `}
    @media ${(props) => props.theme.mediaQuery.mediumOnlyPortrait} {
      width: 100%;
      margin-left: 0;
      margin-top: 10px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isStickyCheckoutButtonEnabled &&
        !props.isCheckoutBannerHidden &&
        `
        width: 100%;
        margin-left: 0;
        margin-top: 10px;
      `}

      ${(props) =>
        props.isPLCCInstantCheckout &&
        !props.isInternationalShipping &&
        `
        width: 100%;
        margin-left: ${props.isAdyenPaymentEnabled ? '2%' : '0'};
        margin-top: ${props.isAdyenPaymentEnabled ? '0px' : '10px'};
      `}
    }
  }
  .paypal-wrapper-atb {
    width: 100%;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-right: 10px;
    }
  }
  .checkout-button.sticky-checkout-button-new {
    .after-pay-block {
      margin: 0 0 0 ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      background-size: 105%;
      border: 1px solid black;
      box-sizing: border-box;
    }
    .paypal-wrapper {
      ${(props) =>
        props.isExpressAfterpayEnabled
          ? `
          background-image: url('${getIconPath('paypal-logo', props)}');
          background-repeat: no-repeat;
          background-size: 70%;
          background-position: 50%;
          overflow: hidden;
          border-radius: ${
            props.theme.brandSpecificStyles.VENMO_BUTTON_OVERLAY.VENMO_OVERLAY_BUTTON_BORDER_RADIUS
          };
          border: 1px solid ${props.theme.colorPalette.venmoBorder};
          box-sizing: border-box;
          height: 42px;
          .paypal-wrapper-content{
            opacity: 0.01;
          }`
          : ''}
    }
    .apple-wrapper {
      margin-left: 8px;
      margin-top: 0;
      height: 42px;
    }
  }
  .venmo-wrapper {
    display: none;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: block;
      width: 100%;
      ${(props) =>
        (!props.isPLCCInstantCheckout ||
          props.isInternationalShipping ||
          props.isAdyenPaymentEnabled) &&
        !props.isPayPalDisabled
          ? `margin-left: 6px;`
          : 'margin-top: 1px;'}

      ${(props) =>
        props.isStickyCheckoutButtonEnabled &&
        !props.isCheckoutBannerHidden &&
        `
      padding: 8px 0px 0px 0px;
      margin-left: 0;
      `}
    }
  }
  .checkoutBtn-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .miniBag-CheckoutBtn-wrapper {
    display: block;
    width: ${(props) => (props.containsExtendedOrder || props.isPayPalDisabled ? '100%' : '52%')};
  }
  .addBagActions-error {
    background: transparent;
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};

    span {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }
  .checkoutBtnTracker {
    display: inline-flex;
    flex: 1;
    width: 100%;
    ${(props) =>
      (props.isStickyCheckoutButtonEnabled || props.isStickyCheckoutPaymentDisabled) &&
      `
    width:100%;
    `}
  }

  .checkoutSkeleton {
    padding: 0px;
    &:hover {
      background: ${(props) => props.theme.colorPalette.blue.C900};
    }
    height: 48px;
    margin-left: ${(props) =>
      props.isInternationalShipping ? '0px' : props.theme.spacing.APP_LAYOUT_SPACING.XXS};
    ${(props) => (!props.isVenmoEnabled && !props.isPayPalEnabled ? `margin-left: 0;` : '')};
    flex: 1;
    background-color: ${(props) => props.theme.colorPalette.blue.C900};
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      margin-left: 0;
    }
  }

  ${(props) =>
    props.isCheckoutBannerHidden &&
    props.isStickyCheckoutButtonEnabled &&
    `
    .sticky-checkout-button-new {
      bottom: 0;
    left: 0;
    position: fixed;
    width: 100%;
    background: ${props.theme.colors.WHITE};
    z-index: ${props.theme.zindex.zLoader};
    margin: 0;
    border-top: ${props.theme.spacing.ELEM_SPACING.XXXS} solid
      ${props.theme.colors.PRIMARY.LIGHTGRAY};
    padding: ${props.theme.spacing.ELEM_SPACING.XS}
      ${props.theme.spacing.ELEM_SPACING.MED};
  }
  `}

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) =>
      props.isScrolling
        ? `opacity: 0;animation: fadeOut ease 1.5s;`
        : `opacity: 1;animation: fadeIn ease 0.2s;`};
    @keyframes fadeOut {
      0% {
        opacity: 1;
      }
      20% {
        opacity: 0;
      }
    }
    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      20% {
        opacity: 1;
      }
    }
  }
  .view-bag-container {
    display: flex;
  }
  .keep-shopping {
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.XXXL};
    padding: 0;
  }
  .afterpay-msg-section {
    text-align: center;
    width: 100%;
    clear: both;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }
  .redesigned-bag-container {
    justify-content: space-between;
  }
  .redesigned-keep-shopping,
  .redesigned-view-bag {
    padding: 16px 0;
    border-radius: 6px;
    width: 49%;
    letter-spacing: 1.08px;
    ${(props) =>
      props.isAddedToBagRedesign
        ? `
    @media ${props.theme.mediaQuery.smallOnly} {
      padding: 10px 0;
      width: 46%;
    }
    `
        : ``}
  }
  .redesigned-keep-shopping {
    &:hover {
      background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
    }
    background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
    &[id^='brand-snj'] {
      ${snjPrimary}
    }
  }
  .keep-shopping-text {
    color: ${(props) => props.theme.brandSpecificStyles.KEEP_SHOPPING_TEXT.COLOR};
  }
  .redesigned-view-bag {
    border: solid 1px ${(props) => props.theme.colorPalette.gray[600]};
  }

  .sticky-action-btn {
    ${(props) =>
      props.isAddedToBagRedesign
        ? `
      @media ${props.theme.mediaQuery.smallOnly} {
      position: absolute;
      bottom: 35px;
      right: 0px;
      padding: 18px 18px 28px 18px;
      box-sizing: border-box;
      box-shadow: 0 -1px 2px 0 rgb(187 187 187 / 50%);
      background: ${props.theme.colorPalette.white};
      z-index: 999;
    }
    `
        : ''}
  }

  .invisible-div {
    position: absolute;
    top: -10px;
    padding-bottom: 10px;
    width: 100%;
    height: 100%;
  }

  .paymentsImage {
    display: inline-block;
    width: 85px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 50px;
    }
    img {
      vertical-align: middle;
    }
  }
  .otherPaymentsImage {
    display: inline-block;
    width: 115px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 63px;
    }
    img {
      vertical-align: middle;
    }
  }
  .paypalPaymentsImage {
    display: inline-block;
    width: 75px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 40px;
    }
    img {
      vertical-align: middle;
    }
  }
  .payPalIcon {
    display: inline-block;
    width: 44px;
    img {
      vertical-align: middle;
      height: 26px;
    }
  }
  .payPalImage {
    display: flex;
    flex-direction: row;
    width: 44px;
  }
  .paymentLink {
    text-decoration: underline;
    cursor: pointer;
    margin-right: 5px;
  }

  img.venmo-overlay-image {
    width: 75px;
    height: 40px;
  }

  img.apple-pay-image {
    height: 12px;
  }

  .apple-pay-button-black {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-bottom: 10px;
    }
  }

  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;

export default ctaStyle;

export const StyledDiv = styled.div`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    z-index: 1;
  }
`;
